import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.css';

// Initialize global Yup configuration
import 'core/validation/yup-config';

// import App from './App';
// import './index.css'
import theme from './components/theme';
import { ToastContainer } from 'react-toastify';
import { AppRoutes } from 'core/routes/routes';
import { AuthContextProvider } from 'core/auth/context';
import { NetworkInterceptor } from 'core/network/interceptor';
import { UserSettingsProvider } from 'core/user.settings/context';
import { ReportProvider } from 'core/report/context';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
  apiKey: 'd8e607aba03ce9b64099a055c1eb1048',
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: [ 'production', 'staging' ],
  plugins: [new BugsnagPluginReact()]
});

const ErrorBoundary = Bugsnag.getPlugin('react')!
  .createErrorBoundary(React)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Data fetched in the last 30s is reused when navigating between pages instead of
            // being refetched on every mount; mutations already invalidate what they touch.
            staleTime: 30 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <AuthContextProvider>
            <NetworkInterceptor>
                <BrowserRouter>
                    <UserSettingsProvider>
                        <ThemeProvider theme={theme}>
                            <QueryClientProvider client={queryClient}>
                                <ReportProvider>
                                    <CssBaseline />
                                    <AppRoutes />
                                    <ToastContainer hideProgressBar position='top-center' />
                                </ReportProvider>
                            </QueryClientProvider>
                        </ThemeProvider>
                    </UserSettingsProvider>
                </BrowserRouter>
            </NetworkInterceptor>
        </AuthContextProvider>
      </ErrorBoundary>
    </React.StrictMode>
);